import React from 'react';
import { useMediaQuery } from 'react-responsive';
import MintelNavigation from 'mintel-navigation';
import { Grid, Text, Interpolate } from 'mintel-react-ui';
import { tablet, desktop } from 'mintel-tokens';

import useTranslation from '../translations';
import AnnouncementContainer from '../AnnouncementContainer';
import styles from './PageWrapper.scss';
import shapesSvg from './shapes/shapes.svg';

const PageWrapper = ({
  children,
  shapeless = false,
  errors = [],
  infos = [],
  successMessage = '',
}: {
  children: React.ReactNode;
  shapeless?: boolean;
  errors?: string[];
  infos?: string[];
  successMessage?: string;
}): JSX.Element => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: parseInt(tablet, 10) - 1 });
  const isTablet = useMediaQuery({ maxWidth: parseInt(desktop, 10) - 1 });

  const spacerColumnProps = shapeless
    ? { width: 2 }
    : {
        width: 0,
        tablet: 2,
        desktop: 1,
      };

  const form = (
    <div className={styles.loginForm}>
      <AnnouncementContainer
        errors={errors}
        infos={infos}
        successMessage={successMessage}
      />
      {children}
    </div>
  );

  return (
    <div className={styles.root}>
      <MintelNavigation noSiteNav logoutLink="" portalNav showLanguage={false}>
        <div className={styles.content}>
          {isMobile ? (
            form
          ) : (
            <Grid>
              <Grid.Row>
                <Grid.Col {...spacerColumnProps} />
                <Grid.Col width={12} tablet={8} desktop={shapeless ? 8 : 4}>
                  <div className={styles.welcomeMessage}>
                    <Text.Heading1>
                      <Interpolate
                        template={t('Welcome to {Mintel}')}
                        values={{
                          Mintel: (
                            <span className={styles.highlight}>
                              <span className={styles.underline} />
                              <span className={styles.highlightText}>
                                Mintel
                              </span>
                            </span>
                          ),
                        }}
                      />
                    </Text.Heading1>
                  </div>
                  {form}
                </Grid.Col>
                <Grid.Col {...spacerColumnProps} />
                {!isTablet && !shapeless && (
                  <Grid.Col
                    width={12}
                    desktop={6}
                    className={styles.shapesContainer}
                  >
                    <div
                      data-testid="shapes"
                      style={{
                        display: 'inline-block',
                        width: 570,
                        height: 600,
                      }}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: shapesSvg }}
                    />
                  </Grid.Col>
                )}
              </Grid.Row>
            </Grid>
          )}
        </div>
      </MintelNavigation>
    </div>
  );
};

export default PageWrapper;
